import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import i18n from "../../../i18n";

interface StatsStripProps {
  referralsCount: number;
  totalEarned: string;
  totalWithdrawn: string;
}

function formatUsdt(v: string): string {
  const n = Number(v);
  if (!Number.isFinite(n)) return "0.00";
  const locale = i18n.language === "en" ? "en-US" : "ru-RU";
  return n.toLocaleString(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

/**
 * Компактный ряд из трёх мини-карточек: приглашённые, всего заработано,
 * всего выведено. Единый визуальный «поясок» между hero-балансом и списком
 * уровней.
 */
export function StatsStrip({
  referralsCount,
  totalEarned,
  totalWithdrawn,
}: StatsStripProps) {
  const { t } = useTranslation("referral");
  const items = [
    {
      label: t("stats.friends"),
      value: `${referralsCount}`,
    },
    {
      label: t("stats.earned"),
      value: `${formatUsdt(totalEarned)}`,
      suffix: "USDT",
    },
    {
      label: t("stats.withdrawn"),
      value: `${formatUsdt(totalWithdrawn)}`,
      suffix: "USDT",
    },
  ] as const;

  return (
    <Box
      sx={{
        marginTop: "10px",
        display: "grid",
        gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
        gap: "8px",
      }}
    >
      {items.map((it) => (
        <Box
          key={it.label}
          sx={{
            padding: "12px 12px",
            borderRadius: "16px",
            backgroundColor: "secondary.main",
            display: "flex",
            flexDirection: "column",
            gap: "4px",
            minWidth: 0,
          }}
        >
          <Typography
            sx={{
              fontSize: "10.5px",
              opacity: 0.55,
              letterSpacing: "0.3px",
              textTransform: "uppercase",
            }}
          >
            {it.label}
          </Typography>
          <Typography
            sx={{
              fontSize: "15px",
              fontWeight: 700,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
            title={`${it.value}${"suffix" in it && it.suffix ? " " + it.suffix : ""}`}
          >
            {it.value}
            {"suffix" in it && it.suffix ? (
              <Typography
                component="span"
                sx={{
                  fontSize: "10px",
                  fontWeight: 500,
                  opacity: 0.5,
                  marginLeft: "3px",
                }}
              >
                {it.suffix}
              </Typography>
            ) : null}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}
